export enum PublicActionType {
    FetchUserPreferencesSuccess = 'FETCH_USER_PREFERENCES_SUCCESS',
    SetNumberOfTilesInWidth = 'SET_NUMBER_OF_TILES_IN_WIDTH',
}
export const INITIALIZE = 'INITIALIZE_PUBLIC_DASHBOARD';
export const initialize = () => ({ type: INITIALIZE });

export const INITIALIZE_SUCCESS = 'INITIALIZE_PUBLIC_DASHBOARD_SUCCESS';
export const initializeSuccess = () => ({ type: INITIALIZE_SUCCESS });

export interface GetUserPreferencesSuccess {
    type: PublicActionType.FetchUserPreferencesSuccess;
    payload: { measurementSystem: string; tilesInWidth: string | null };
}
export const getUserPreferencesSuccess = (payload: {
    measurementSystem: string;
    tilesInWidth: string | null;
}): GetUserPreferencesSuccess => ({
    type: PublicActionType.FetchUserPreferencesSuccess,
    payload,
});

export interface SetNumberOfTilesInWidth {
    type: PublicActionType.SetNumberOfTilesInWidth;
    width: number;
}

export const setNumberOfTilesInWidth = (width: number): SetNumberOfTilesInWidth => ({
    type: PublicActionType.SetNumberOfTilesInWidth,
    width,
});

export type EmptyAction = { type: 'empty' };
export const emptyAction: EmptyAction = { type: 'empty' };

export type PublicActions = GetUserPreferencesSuccess | SetNumberOfTilesInWidth | EmptyAction;
